import Breadcrumb from "../components/Breadcrumb";
import AllClients from "../components/AllClients";

const AllClientsPage = () => {
  return (
    <>
      {/* Breadcrumb */}
      <Breadcrumb title="All Clients" />

      {/*All Clients Layer*/}
      <AllClients />
    </>
  );
};

export default AllClientsPage;
